import { useEnum } from "@/api/services/global/enum";
import { InnerBox } from "@/components/elements/InnerBox";
import { TalentInfoItem } from "@/features/talent/components/talent-detail/TalentInfoItem";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { findLabelByValue } from "@/utils/object";
import { Grid, Collapse } from "@mui/material";

type TTalentRecruitmentStatusProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentRecruitmentStatus: FCC<TTalentRecruitmentStatusProps> = ({ defaultValues }) => {
  const { data: recruitmentStatusOptions } = useEnum("ERecruitmentStatus");
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <CollapsibleSectionHeader title="ステータス状況" expanded={expanded} onToggle={toggle} />
      <Collapse in={expanded}>
        <Grid mt={1} container spacing={2}>
          <Grid item xs={4}>
            <TalentInfoItem
              isShowDivider={false}
              label="求職活動ステータス"
              value={findLabelByValue(recruitmentStatusOptions, defaultValues?.recruitmentStatus)}
            />
          </Grid>

          <Grid item xs={4}>
            <TalentInfoItem
              isShowDivider={false}
              label="紹介事業所名"
              value={defaultValues?.matchOffice?.officeName}
            />
          </Grid>

          <Grid item xs={4}>
            <TalentInfoItem label="人材担当者" value={defaultValues?.personInCharge?.fullName} isShowDivider={false} />
          </Grid>
        </Grid>
      </Collapse>
    </InnerBox>
  );
};
